import { observable, action } from "mobx";

class MyRegularWorkshops {
  @observable workshops = [];
  @observable thisWorkshop = {};

  @action setNewList = data => {
    this.workshops = data;
  };

  @action setthisWorkshop = id => {
    console.log("you targeted this id =", id);
  };
}

export default new MyRegularWorkshops();



// WEBPACK FOOTER //
// ./src/stores/MyRegularWorkshops.js